import { render, staticRenderFns } from "./AccountSideNav.vue?vue&type=template&id=3fe2d4ea&scoped=true"
import script from "./AccountSideNav.vue?vue&type=script&lang=js"
export * from "./AccountSideNav.vue?vue&type=script&lang=js"
import style0 from "./AccountSideNav.vue?vue&type=style&index=0&id=3fe2d4ea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fe2d4ea",
  null
  
)

export default component.exports